import MojitoCore from 'mojito/core';
import BetReceiptImpl from './bet-receipt.js';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';

const { UIControllerView } = MojitoCore.Presentation;

/**
 * Bet receipt is a component for displaying recently placed bets.
 *
 * @class BetReceipt
 * @name module
 * @memberof Mojito.Modules.BetReceipt
 */

/**
 * Bet receipt prop types.
 *
 * @memberof Mojito.Modules.BetReceipt.module
 *
 * @property {Function} [scrollFullscreenBetslipToTop = () => {}] - Function that scrolls the fullscreen betslip content to top.
 * @property {Function} [onClear = () => {}] - Function called when receipt is cleared.
 */

const propTypes = {
    scrollFullscreenBetslipToTop: PropTypes.func,
    onClear: PropTypes.func,
};

const defaultProps = {
    scrollFullscreenBetslipToTop: noop,
    onClear: noop,
};

export default UIControllerView('BetReceipt', BetReceiptImpl, propTypes, defaultProps);
